import React, { useCallback } from 'react';
import { Timer, Action, Check, Box, Top, Bottom, ActiveTaskName } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { formatSecondsDuration } from '../../../helpers/common';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, ICON_SIZE } from '../../../global/constants';
import IconButton from '../../button/iconButton';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import { useTimeTracking } from '../hooks/useTimeTracking';

const TimerSection: React.FC = () => {
  const { timeTrackingStore, taskStore } = rootStore;
  const { activeTimeLogs } = timeTrackingStore || {};
  const { tasks } = taskStore || {};

  const { currentActiveTask, currentStartTime, isLoading, onClickStartStop, onClickTaskDetails } = useTimeTracking({
    activeTimeLogs,
    tasks
  });

  const handlePauseClick = useCallback(() => {
    onClickStartStop(activeTimeLogs[0]['_id'], activeTimeLogs[0]?.TimerStartedAt, activeTimeLogs[0]);
  }, [onClickStartStop, activeTimeLogs]);

  if (activeTimeLogs?.length === 0) return null;

  return (
    <Timer className='timer'>
      <Box className='box'>
        <Top role='button' onClick={onClickTaskDetails} className='top-section'>
          <Check>
            <SVGIcon
              name='task-todo-icon'
              width={ICON_SIZE.MD}
              height={ICON_SIZE.MD}
              viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
              className='svg-icon'
            />
          </Check>
          <ActiveTaskName>{currentActiveTask?.name}</ActiveTaskName>
        </Top>
        <Bottom>
          <Action>
            <SVGIcon
              name='time-icon'
              width={ICON_SIZE.LG}
              height={ICON_SIZE.LG}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
            <span>{formatSecondsDuration(currentStartTime?.time, 'label')}</span>{' '}
          </Action>
          <IconButton
            iconName='pause-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.SECONDARY}
            type='rounded'
            isDisabled={isLoading}
            onClick={handlePauseClick}
          />
        </Bottom>
      </Box>
    </Timer>
  );
};

export default observer(TimerSection);
